/**
 * Presentation Layer - Mobile Drawer Component
 * 
 * Drawer animado que se desliza desde la izquierda para móviles.
 */

import React, {useEffect} from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {Icon} from '../../shared/components/Icon';

// Importar estilos CSS para animaciones
if (typeof window !== 'undefined') {
  require('./MobileDrawer.css');
}

interface MobileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const MobileDrawer: React.FC<MobileDrawerProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  useEffect(() => {
    // Prevenir scroll del body cuando el drawer está abierto
    if (typeof document !== 'undefined') {
      if (isOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
    
    return () => {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = '';
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <View style={styles.container} nativeID="drawer-container" dataSet={{drawerContainer: 'true'}}>
      {/* Overlay */}
      <TouchableOpacity
        style={styles.overlay}
        activeOpacity={1}
        onPress={onClose}
      />
      
      {/* Drawer Content */}
      <View style={styles.drawer} nativeID="drawer-content" dataSet={{drawerContent: 'true'}}>
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'fixed' as any,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
  },
  overlay: {
    position: 'absolute' as any,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  drawer: {
    position: 'absolute' as any,
    top: 0,
    left: 0,
    bottom: 0,
    width: '80%',
    maxWidth: 280,
    backgroundColor: '#1e3a8a',
    shadowColor: '#000',
    shadowOffset: {width: 2, height: 0},
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 16,
  },
});
